import DateInputRe from "components/elements/DateInputRe";
import Table from "components/elements/Table";
import { useNavigate, useOutletContext } from "react-router-dom";
import { LS_CLONE_REGROUP_KEY, LS_NAME_REGROUP_NAME } from "core/Constants";
import dataProvider from "core/DataProvider";
import { useState } from "react";
//import { useNavigate } from "react-router-dom";
import { ReactComponent as EyeIcon } from "../../../images/eye.svg";
//import IconInput from "components/elements/IconInput";
//import utility from "core/Utils";
import toast from "react-hot-toast";
//import Exporter from "components/elements/Exporter";
import "../../../styles/group_tab.css";
import { useEffect } from "react";
import { useCallback } from "react";
import Modal from "components/elements/Modal";
import SubscriptionPreview from "./SubscriptionPreview";
import fetchSubscriptions from "./subscriptionsService";

const Tabs = () => {

  const navigate = useNavigate();
  // State to track the active tab
  const [activeTab, setActiveTab] = useState("tab1");
  const [grp_details, setGroupsDet] = useState([]);
  const [grp_clients, setGroupsClients] = useState("");
  const [grp_clients_sub, setGroupsClientsSub] = useState("");
  const [subscriptionFrom, setSubscriptionFrom] = useState("");
  const [errors, setErrors] = useState({});
  const [inputClientSpotTotal, setClientSpotTotal] = useState("");
  const [inputClientUsersTotal, setClientUsersTotal] = useState("");
  const [previewData, setPreviewData] = useState({});
  const [isPreview, setIsPreview] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [subChk, setSubChk] = useState([]);
  const [selectallsub, setSelectAllSub] = useState(false);
  const [formData, setFormData] = useState({
    subcription_frm: "", subcription_to: "", primary_spot: "", group_spot: "", group_users: "", back_days: "", tolerance_day: "", customise_rate: "", multiple_advertise: "", clients: [{ client_id: "", client_new_spot: "", client_new_users: "" }], subscriptions: []
  });


  // Function to handle tab switching
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-GB"); // "en-GB" gives DD/MM/YYYY format
  };
  const [search, setSearch] = useState("");
  const [loading] = useState(false);
  const token = useOutletContext();
  const previewModal = (
    <SubscriptionPreview
      onClose={(action = null) => {
        setIsPreview(false);
        if (action) {
          if (action === "refresh_listing") {
            // initialLoad();
          }
        }
      }}
      data={previewData}
      allowClone={true}
      allowModify={!token.client_type}
    />
  );

  const modal = (
    <Modal onClose={() => setModalVisible(false)}>{modalContent}</Modal>
  );
  const fetchSubDetails = async id => {
    try {
      let data = await dataProvider.network.get("subscriptions/full?id=" + id);

      data.advertisers = data.advertisers.map(x => JSON.parse(x));
      data.categories = data.categories.map(x => JSON.parse(x));
      data.brands = data.brands.map(x => JSON.parse(x));
      data.captions = data.captions.map(x => JSON.parse(x));
      data.channels = data.channels.map(x => JSON.parse(x));

      let previewData = {
        id: data.id,
        group: { label: data.group_name, value: data.group_id },
        client: { label: data.client_name, value: data.client_id },
        contentType: { value: data.content_type },
        advertiser: { label: data.advertisers.map(x => x.name).join(",") },
        advertiserList: data.advertisers,
        periodFrom: data.period_from,
        periodTo: data.period_to,
        category: data.categories.map(x => ({ label: x.name })),
        categoryList: data.categories,
        brand: data.brands.map(x => ({ label: x.name })),
        brandList: data.brands,
        caption: data.captions.map(x => ({ label: x.name })),
        captionList: data.captions,
        channels: data.channels.map(x => ({ label: x.name })),
        channelsList: data.channels,
        edit: data.edits.map(x => ({ label: x })),
        user: token,
      };

      setPreviewData(previewData);
      setIsPreview(true);
    } catch (error) {
      console.error(error);
      toast.error("Error fetching subscriptions details");
    }
  };


  const gid = JSON.parse(localStorage.getItem(LS_CLONE_REGROUP_KEY));
  const gname = JSON.parse(localStorage.getItem(LS_NAME_REGROUP_NAME));
  const get_grp_details = async () => {
    try {

      if (gid) {
        let grp_details = await dataProvider.network.post("renewal/groups/subs", { group_id: gid });
        if (grp_details) {
          // console.log('grp details', grp_details);
          setGroupsDet(grp_details);
        }
      }
    } catch (error) {
      toast.error("Failed to load groups Details");
    } finally {
      // setLoading(false);
    }
  };


  const curr_sub_fdate = grp_details.length > 0 ? grp_details[0].subscription_from : " ";
  const curr_sub_tdate = grp_details.length > 0 ? grp_details[0].subscription_to : " ";
  const curr_users = grp_details.length > 0 ? grp_details[0].users : " ";
  const curr_back_days = grp_details.length > 0 ? grp_details[0].back_days : " ";
  const curr_torance_days = grp_details.length > 0 ? grp_details[0].tolerance_days : " ";
  const curr_custom_rate = grp_details.length > 0 ? grp_details[0].custom_rate : " ";
  const curr_allocated_spots = grp_details.length > 0 ? grp_details[0].allocated_spots : "";
  const curr_total_spots = grp_details.length > 0 ? grp_details[0].spots : "";



  const headerMap = {
    client_name: "Client Name",
    current_spot: "Current Spot",
    new_spot: "New Spot",
    current_user: "Current User",
    new_user: "New User"
  };

  // State to store only the input changes for `client_new_spot` and `client_new_users`
  const [clientInputData, setClientInputData] = useState([]);

  const data = async (gid) => {
    try {
      let grp_clients1 = await dataProvider.network.post("renewal/group/clients", { group_id: gid });

      // Format the fetched data, but decouple from input elements
      const formattedClients = grp_clients1.map((x) => ({
        ...x,
        client_name: x.name,
        current_spot: x.spots,
        current_user: x.users,
      }));

      setGroupsClients(formattedClients);
    } catch (error) {
      console.log(error);
      toast.error("Failed to load Clients");
    }
  };


  const editClientBCK = client => {
    navigate("/clients/renewList");
  }

  const handleDynamicChangeSubSelectAll = (e) => {
    //const { checked, value } = e.target;
    const allChecked = e.target.checked;
    console.log('step 1', allChecked);


    if (allChecked === true) {
      grp_clients_sub.forEach((x, index) => {
        handleDynamicChangeSub(index, {
          target: { checked: allChecked, value: x.id }
        }, x.client_id);
      });
    } else {
      setFormData((formData) => {
        let updatedSubscriptions = [];



        const newFormData = { ...formData, subscriptions: updatedSubscriptions };
        console.log("Updated FormData Inside setFormData11:", newFormData); // ✅ Logs the correct updated data

        return newFormData;

      });
    }
    setSelectAllSub(allChecked); // Toggle "Select All" state
    // dataSub();
  };

  const headerMapSub = {
    action: (
      <>
        <input
          type="checkbox"
          onChange={(e) => handleDynamicChangeSubSelectAll(e)}
          checked={selectallsub}
          value="1"
          name="sub_id_all"
        />
      </>
    ),
    sub_id: "SUB ID",
    client_id: "CLIENT ID",
    client_name: "CLIENT NAME",
    advertiser: "ADVERTISER",
    sub_details: "SUB DETAILS",
    period_from: "PERIOD FROM",
    period_to: "PERIOD TO"
  };
  const dataSub = async (gid) => {
    try {
      let grp_clients_sub = await dataProvider.network.post("renewal/group/clients/subs", { group_id: gid });


      grp_clients_sub = grp_clients_sub.map((x, index) => ({
        ...x,
        // action: <input type="checkbox" onChange={(e) => handleDynamicChangeSub(index, e, x.client_id)} checked={Boolean(formData.subscriptions.some(sub => sub.sub_id === x.id))} value={x.id} name="sub_id" />,
        sub_id: x.id,
        client_id: x.client_id,
        client_name: x.client_name,
        advertiser: x.advertiser,
        // sub_details: <div className="action flex flex-v-center" onClick={() => fetchSubDetails(x.id)}>
        //   <div className="action-button flex flex-center">
        //     <EyeIcon />
        //   </div>
        // </div>,
        period_from: formatDate(x.subscription_from),
        period_to: formatDate(x.subscription_to),
      }));


      setGroupsClientsSub(grp_clients_sub);
    } catch (error) {
      toast.error("Failed to load group subcription");
    } finally {
      // setLoading(false);
    }
  };


  const validateGroupSpot = (totalSpots) => {
    if (totalSpots <= 0) {
      setErrors((prevErrors) => ({ ...prevErrors, group_spot: "Total spots must be greater than 0." }));
      return false;
    }

    // ✅ Clear error only if `totalSpots` is valid
    setErrors((prevErrors) => ({ ...prevErrors, group_spot: null }));
    return true;
  };

  const handleDynamicChange = (index, e, cid) => {

    console.log("FormData 2 : ", formData);

    if (!e || !e.target) {
      console.error("Event object is undefined!");
      return;
    }
    const { name, value } = e.target;
    // If input is not a number, reset it immediately
    if (!/^\d*$/.test(value)) {
      e.target.value = ""; // Reset input field directly
    }

    setClientInputData((prevState) => {
      const updatedClients = [...prevState];

      if (!updatedClients[index]) {
        updatedClients[index] = { client_id: cid, client_new_spot: "", client_new_users: "" };
      }

      updatedClients[index] = {
        ...updatedClients[index],
        [name]: value, // Store the input value dynamically
      };

      // Calculate the total sum of all `client_new_spot`
      const totalSpots = updatedClients.reduce((sum, client) => sum + (parseInt(client.client_new_spot, 10) || 0), 0);

      // Validate against primary_spot
      if (totalSpots > formData.primary_spot) {
        toast.error("Total allocated Client spots cannot exceed the New Total Spots (SOW)!");
        return prevState; // Prevent updating state
      }

      // Calculate the total sum of all `client_new_users`
      const totalSpotsUsers = updatedClients.reduce((sum, client) => sum + (parseInt(client.client_new_users, 10) || 0), 0);

      // Validate against group_users
      if (totalSpotsUsers > formData.group_users) {
        toast.error("Total allocated Client Users cannot exceed the group Users!");
        return prevState; // Prevent updating state
      }

      // Validate group spot if the `validateGroupSpot` function exists
      if (validateGroupSpot(totalSpots)) {
        setErrors((errors) => ({ ...errors, group_spot: null })); // Clear error when valid
      }

      // Update the total spots
      setClientSpotTotal(totalSpots);
      setClientUsersTotal(totalSpotsUsers);

      // Update the formData state with the new group_spot and clients
      setFormData((formData) => ({
        ...formData,
        clients: updatedClients,
        group_spot: totalSpots,
      }));

      return updatedClients;
    });

    console.log("FormData 3 : ", formData);
  };

  const handleDynamicChangeSub = (index, e, cid) => {
    const { checked, value } = e.target;
    // const { value, checked } = e.target;
    const subId = parseInt(value, 10); // Ensure sub_id is an integer

    console.log("Values : ", [checked, subId, cid]);

    setFormData((prevFormData) => {
      const updatedSubscriptions = [...(prevFormData.subscriptions || [])];

      if (!updatedSubscriptions[index]) {
        updatedSubscriptions[index] = { client_id: cid, sub_id: "" };
      }

      updatedSubscriptions[index] = {
        ...updatedSubscriptions[index],
        sub_id: checked ? e.target.value : "", // Update the sub_id only when checked
      };

      return { ...prevFormData, subscriptions: updatedSubscriptions };
    });

  };

  const chk_group_count = (e) => {

    if (!e || !e.target) {
      console.error("Event object is undefined!");
      return; // Prevents further execution
    }
    const { name, value } = e.target;
    if (inputClientUsersTotal > value) {

      e.target.value = '';
      formData.group_users = '';
      toast.error("Total allocated Client Users cannot exceed the group Users!");
    }
  }
  const handleStaticChange_chk = (e) => {
    if (!e || !e.target) {
      console.error("Event object is undefined!");
      return; // Prevents further execution
    }
    const { name, value } = e.target;
    if (inputClientSpotTotal > value) {
      e.target.value = '';
      formData.primary_spot = '';
      toast.error("Total allocated Client spots cannot exceed the New Total Spots (SOW)!");
    }

  }
  const handleStaticChange = (e) => {
    if (!e || !e.target) {
      console.error("Event object is undefined!");
      return; // Prevents further execution
    }
    const { name, value } = e.target;
    if (/^\d*$/.test(value)) {
      setFormData((formData) => ({
        ...formData,
        [e.target.name]: e.target.value, // Dynamically update the input field
      }));

    }
    // Remove error when valid data is entered
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name],
    }));
  };
  const handleStaticChangeDate = (e) => {
    if (!e || !e.target) {
      console.error("Event object is undefined!");
      return; // Prevents further execution
    }
    const { name, value } = e.target;
    setFormData((formData) => ({
      ...formData,
      [name]: value, // Dynamically update the input field
    }));
    // Remove error when valid data is entered
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name],
    }));
  };
  // Validation Logic
  const validate = () => {
    let newErrors = {};
    //console.log('tttt', formData.group_spot);
    // Static Fields Validation
    if (!formData.subcription_frm || !formData.subcription_frm) newErrors.subcription_frm = "Subcription Form Date is required";
    if (!formData.subcription_to || !formData.subcription_to) newErrors.subcription_to = "Subcription To Date is required";
    if (!formData.primary_spot || !formData.primary_spot.trim()) newErrors.primary_spot = "Primary Spot is required";
    // if (!formData.group_spot || formData.group_spot === 0) newErrors.group_spot = "Group Spot is required";
    if (!formData.group_users || !formData.group_users.trim()) newErrors.group_users = "Group User is required";
    if (!formData.back_days || !formData.back_days.trim()) newErrors.back_days = "Back Days is required";
    if (!formData.tolerance_day || !formData.tolerance_day.trim()) newErrors.tolerance_day = "Tolerance Day is required";
    if (inputClientSpotTotal <= 0) {
      newErrors.group_spot = "Group Spot is required";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      handleTabClick("tab1");
    } else {
      return Object.keys(newErrors).length === 0; // Return true if no errors
    }
  };

  const handleReFormSubmit = async (e) => {
    e.preventDefault();

    // console.log("Final FormData : ", formData);

    // return ;
    if (validate()) {
      //console.log("Submitted Data:", formData);
      const transClientformData = formData.clients.map(item => ({
        client_id: item.client_id,
        allocated_spots: parseInt(item.client_new_spot, 10), // Convert to integer
        users: parseInt(item.client_new_users, 10),
      }));
      const transClientSubData = formData.subscriptions.filter(item => item.sub_id).map(item => ({
        id: item.sub_id,
        client_id: item.client_id,
        subscription_from: formData.subcription_frm,
        subscription_to: formData.subcription_to
      }));
      let data = {
        payload: JSON.stringify({
          group: {
            groupid: gid,
            subscription_from: formData.subcription_frm,
            subscription_to: formData.subcription_to,
            gspots:parseInt(formData.primary_spot,10),
            allocated_spots: parseInt(formData.group_spot, 10), // Convert to integer
            users: parseInt(formData.group_users, 10),
            back_days: parseInt(formData.back_days, 10),
            tolerance_days: parseInt(formData.tolerance_day, 10),
            custom_rate: parseInt(formData.customise_rate, 10) || 0,
            //multiple_advertise: formData.multiple_advertise,
            modified_by: 1,
            clients: transClientformData, // Ensure client data is sent
            subscriptions: transClientSubData
          }

        })
      };

      console.log("Final Submission Data:", data);
      try {
        const response = await dataProvider.network.post("renewal/group/renew", data);
        // console.log("API Response:", response);

        if (response.status === 200 || response.status === 201 || response.status === true) {
          toast.success("Renewed successfully!");
          setTimeout(() => {
            navigate("/clients/renewList");  // Change '/success' to your desired path
          }, 2000);

        } else {
          toast.error("Renewal failed!");
        }
      } catch (error) {
        //console.error("API Error:", error);
        toast.error("Failed to form submit");
      }

    }
  };

  useEffect(() => {
    get_grp_details();
    data(gid);
    dataSub(gid);
    //handleStaticChange();
  }, []);

  useEffect(() => {
    const loadSubscriptions = async () => {
      const subscriptions = await fetchSubscriptions(gid);
      setGroupsClientsSub(subscriptions);

      await data(gid);
    };

    loadSubscriptions();
    console.log("FormData : ", formData);
  }, [gid]);


  return (

    <form onSubmit={handleReFormSubmit}>
      {isPreview && previewModal}
      {modalVisible && modal}
      <div className="row box grp-title">{gname}</div>
      <div>
        <div className="tab-contain-div">
          <button type="button" className={`grp-tab-button ${activeTab === "tab1" ? "active" : ""}`} onClick={() => handleTabClick("tab1")}>
            SPOT & USER
          </button>
          <button type="button" className={`grp-tab-button ${activeTab === "tab2" ? "active" : ""}`}
            onClick={() => handleTabClick("tab2")}>
            SUBCRIPTION
          </button>
          <button className="tab-button-grp" type="submit">Submit</button>
          <button type="button" className="tab-button-bck" onClick={() => editClientBCK()}>BACK</button>
        </div>

        {/* Tab Content */}
        <div className="tab-data-contain">
          {activeTab === "tab1" && <div>

            <div className="group-details box">
              <div className="row-grp">
                <div className="column-grp grp-left" >
                  <h3>Current Subcription Date</h3>
                  <p className="left_p">{formatDate(curr_sub_fdate)} - {formatDate(curr_sub_tdate)}</p>
                  <br />
                  <h3>Current Total Spot(SOW)</h3>
                  <p className="left_p">{curr_total_spots}</p>
                  <br />
                  <h3>Current Allocated Spot</h3>
                  <p className="left_p">{curr_allocated_spots}</p>
                  <br />
                  <h3>Current Group Users</h3>
                  <p className="left_p">{curr_users}</p>
                  <br />
                  <h3>Current Back Days</h3>
                  <p className="left_p">{curr_back_days}</p>
                  <br />
                  <h3>Current Tolerance Day</h3>
                  <p className="left_p">{curr_torance_days}</p>
                  <br />
                  <h3>Current Customize Rate</h3>
                  <p className="left_p">{curr_custom_rate}</p>

                </div>
                <div className="column-grp grp-middle" >
                  <h3>New Subcription Date <span className="text-red-500 ml-1">*</span></h3>
                  <p className="flex"><DateInputRe
                    name="subcription_frm"
                    value={formData.subcription_frm}
                    onChange={(val) => {
                      setFormData((prev) => ({
                        ...prev,
                        subcription_frm: val,
                      }));
                      handleStaticChangeDate({
                        target: { name: "subcription_frm", value: val },
                      });
                    }}
                  /> &nbsp; _ &nbsp;<DateInputRe name="subcription_to" value={formData.subcription_to}

                    onChange={val => {
                      setSubscriptionFrom(val);
                      handleStaticChangeDate({
                        target: { name: "subcription_to", value: val }
                      });
                    }}
                    /></p>
                  <p> {errors.subcription_frm && errors.subcription_to ? <span className="errorDisplay">Subscription From and To Date are required.</span>
                    : errors.subcription_frm ? <span className="errorDisplay">{errors.subcription_frm}</span>
                      : errors.subcription_to ? <span className="errorDisplay">{errors.subcription_to}</span> : null
                  }</p>
                  <br />
                  <h3>New Total Spot (SOW)<span className="text-red-500 ml-1">*</span></h3>
                  <p><input type="text" title="primary_spot" maxLength="10" onChange={handleStaticChange} onBlur={handleStaticChange_chk} name="primary_spot" value={formData.primary_spot || ""} /></p>
                  <p>{errors.primary_spot && <span className="errorDisplay">{errors.primary_spot}</span>}</p>
                  <br />
                  <h3>New Allocated Spot <span className="text-red-500 ml-1">*</span></h3>
                  <p><input name="group_spot" maxLength="10" value={inputClientSpotTotal} className="no-drop" disabled /></p>
                  <p>{errors.group_spot && <span className="errorDisplay">{errors.group_spot}</span>}</p>
                  <br />
                  <h3>New Group Users <span className="text-red-500 ml-1">*</span></h3>
                  <p><input name="group_users" maxLength="10" onChange={handleStaticChange} onBlur={chk_group_count} value={formData.group_users} /></p>
                  <p>{errors.group_users && <span className="errorDisplay">{errors.group_users}</span>}</p>
                  <br />
                  <h3>New Back Days <span className="text-red-500 ml-1">*</span></h3>
                  <p><input name="back_days" maxLength="10" onChange={handleStaticChange} value={formData.back_days} /></p>
                  <p>{errors.back_days && <span className="errorDisplay">{errors.back_days}</span>}</p>
                  <br />
                  <h3>New Tolerance Day <span className="text-red-500 ml-1">*</span></h3>
                  <p><input name="tolerance_day" maxLength="10" onChange={handleStaticChange} value={formData.tolerance_day} /></p>
                  <p>{errors.tolerance_day && <span className="errorDisplay">{errors.tolerance_day}</span>}</p>
                  <br />
                  <h3 >New Customize Rate  <span style={{ float: 'right' }} >Multiple Advertise</span></h3>
                  <p><input name="customise_rate" maxLength="10" onChange={handleStaticChange} value={formData.customise_rate} className="inp-cal" style={{ marginLeft: -2 + 'px' }} /> <input
                    type="checkbox" style={{ float: 'right', marginTop: 15 + 'px' }}
                    name="multiple_advertise"
                    className="inp-cal"
                    checked={formData.multiple_advertise}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, multiple_advertise: e.target.checked }))
                    }
                  /> </p>
                  <p>{errors.customise_rate && <span className="errorDisplay">{errors.customise_rate}</span>}</p>
                </div>
                <div className="column-grp grp-right" >
                  <div className="group-details boxr table-data-grp">

                    {grp_clients &&
                      <Table
                        headers={headerMap}
                        data={grp_clients.map((client, index) => ({
                          ...client,
                          new_spot: (
                            <input
                              onChange={(e) => handleDynamicChange(index, e, client.client_id)}
                              placeholder="Enter Value"
                              name="client_new_spot"
                              maxLength="10"
                              value={clientInputData[index]?.client_new_spot || ""}
                            />
                          ),
                          new_user: (
                            <input
                              onChange={(e) => handleDynamicChange(index, e, client.client_id)}
                              placeholder="Enter Value"
                              name="client_new_users"
                              maxLength="10"
                              value={clientInputData[index]?.client_new_users || ""}
                            />
                          ),
                        }))}
                        search={search}
                      />
                    }

                  </div>
                </div>
              </div>
            </div>


          </div>}
          {activeTab === "tab2" && <div >
            <div className="group-details box">
              <div className="table-wrapper"><div className="table-data-grp" >
                <Table
                  headers={headerMapSub}
                  data={grp_clients_sub.map((x, index) => ({
                    ...x,
                    action: (
                      <input
                        type="checkbox"
                        onChange={(e) => handleDynamicChangeSub(index, e, x.client_id)}
                        checked={Boolean(formData.subscriptions[index]?.sub_id)}
                        value={x.id}
                        name="sub_id"
                      />
                    ),
                    sub_details: (
                      <div className="action flex flex-v-center" onClick={() => fetchSubDetails(x.id)}>
                        <div className="action-button flex flex-center">
                          <EyeIcon />
                        </div>
                      </div>
                    ),
                  }))}
                  search={search}
                />
              </div></div></div>
          </div>}
        </div>
      </div>
    </form>

  );
};

export default Tabs;